import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(4),
    marginBottom: 12,
    fontSize: 50,
    color: theme.palette.grey[500],
  },
  timerWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  timer: {
    fontSize: 20,
    color: theme.palette.primary.main,
    margin: theme.spacing(0, 1),
  },
  paragraph: {
    marginBottom: 0,
  },
}));
